import { useCallback } from 'react';
import type { VibranceValue } from '../../lib/adjustments/vibrance';
import { RangeRow } from './RangeRow';
import type { AdjustmentPanelProps } from './registry';

export function VibrancePanel({ value, onChange }: AdjustmentPanelProps<VibranceValue>) {
  const set = useCallback(
    (patch: Partial<VibranceValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Vibrance"
        min={-100}
        max={100}
        step={1}
        value={value.vibrance}
        onChange={(v) => set({ vibrance: v })}
      />
      <RangeRow
        label="Saturation"
        min={-100}
        max={100}
        step={1}
        value={value.saturation}
        onChange={(v) => set({ saturation: v })}
      />
    </div>
  );
}
